var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoFooterInstagran(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico-footer-instagran",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.68,
    height: 30.68,
    viewBox: "0 0 30.68 30.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_1_3",
    "data-name": "Component 1 \\u2013 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2887",
    "data-name": "Path 2887",
    d: "M212.872,209.936A2.936,2.936,0,1,1,209.936,207,2.936,2.936,0,0,1,212.872,209.936Zm0,0",
    transform: "translate(-194.596 -194.596)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2888",
    "data-name": "Path 2888",
    d: "M149.573,137.515a2.917,2.917,0,0,0-1.672-1.672,4.874,4.874,0,0,0-1.635-.3c-.929-.042-1.208-.051-3.56-.051s-2.631.009-3.559.051a4.877,4.877,0,0,0-1.635.3,2.918,2.918,0,0,0-1.672,1.672,4.876,4.876,0,0,0-.3,1.636c-.042.929-.051,1.207-.051,3.56s.009,2.63.051,3.559a4.874,4.874,0,0,0,.3,1.635,2.917,2.917,0,0,0,1.672,1.672,4.867,4.867,0,0,0,1.636.3c.929.042,1.207.051,3.559.051s2.631-.009,3.559-.051a4.868,4.868,0,0,0,1.636-.3,2.917,2.917,0,0,0,1.672-1.672,4.878,4.878,0,0,0,.3-1.635c.042-.929.051-1.208.051-3.559s-.009-2.631-.051-3.56A4.867,4.867,0,0,0,149.573,137.515Zm-6.867,9.718a4.523,4.523,0,1,1,4.523-4.523A4.523,4.523,0,0,1,142.706,147.233Zm4.7-8.168a1.057,1.057,0,1,1,1.057-1.057A1.057,1.057,0,0,1,147.408,139.065Zm0,0",
    transform: "translate(-127.366 -127.37)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3142",
    "data-name": "Group 3142"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2889",
    "data-name": "Path 2889",
    d: "M15.34,0A15.34,15.34,0,1,0,30.68,15.34,15.342,15.342,0,0,0,15.34,0ZM24.1,18.972a6.463,6.463,0,0,1-.409,2.138,4.5,4.5,0,0,1-2.576,2.576,6.467,6.467,0,0,1-2.138.409c-.939.043-1.239.053-3.632.053s-2.692-.01-3.632-.053a6.467,6.467,0,0,1-2.138-.409A4.5,4.5,0,0,1,6.994,21.11a6.461,6.461,0,0,1-.409-2.138c-.043-.94-.053-1.24-.053-3.632s.01-2.692.053-3.632A6.463,6.463,0,0,1,6.994,9.57,4.507,4.507,0,0,1,9.57,6.994a6.469,6.469,0,0,1,2.138-.409c.939-.043,1.239-.053,3.632-.053s2.692.01,3.632.053a6.47,6.47,0,0,1,2.138.409A4.505,4.505,0,0,1,23.686,9.57a6.462,6.462,0,0,1,.41,2.138c.043.939.053,1.239.053,3.632S24.138,18.032,24.1,18.972Zm0,0",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFooterInstagran);
export default __webpack_public_path__ + "static/media/ico-footer-instagran.e5a280e9d3217b18f83ecdaeeea50016.svg";
export { ForwardRef as ReactComponent };